import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Typography, Tabs, Tab, AppBar } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import Button from 'components/ButtonMaterial'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { removeSearch, fetchSavedSearches } from 'services/api'
import { showFlashMessageOnUnexpectedError } from 'actions'
import isempty from 'lodash.isempty'
import { amtFmt, sanitizeFilters } from 'utils'
import { fetchSavedProperties } from 'services/api'
import { isUserLogged } from 'utils'
import PropertyList from 'components/PropertyList'

const styles = theme => ({
  root: {
    flexGrow: 1,
  },
  appBar: {
    backgroundColor: '#fff !important',
    color: 'rgba(0, 0, 0, 0.87)',
    boxShadow: 'none',
    '&selected': {
      color: '#00bcb5',
    },
  },
  selected: {
    color: '#00bcb5',
  },
  tabsRoot: {
    textTransform: 'capitalize',
    textAlign: 'left',
    [theme.breakpoints.up('sm')]: {
      fontSize: '0.9rem',
    },
  },
  panel: {
    paddingTop: '5px',
  },
  tabRoot: {
    borderBottom: '1px solid #e8e8e8',
  },
  indicator: {
    height: '3px',
    backgroundColor: '#00bcb5',
  },
  card: {
    display: 'flex',
    borderRadius: '0px',
    boxShadow: 'none',
    justifyContent: 'space-between',
    marginBottom: '40px',
  },
  details: {
    display: 'flex',
  },
  content: {
    margin: '10px 0',
  },
  locationContent: {
    color: '#231f20',
    fontSize: '16px',
    marginBottom: '3px',
  },
  filtersContent: {
    color: '#00bcb5',
    fontSize: '12px',
  },
  button: {
    color: 'black',
    textTransform: 'capitalize',
    minWidth: '90px',
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  cardLink: {
    outline: 'none',
    display: 'block',
    margin: '0',
    fontSize: 0,
    textDecoration: 'none',
    cursor: 'pointer',
  },
})

class InvestorSavedSearches extends Component {
  constructor(props) {
    super(props)
    this.state = {
      savedSearches: [],
      isRemoving: false,
      searchesFetched: false,
      propFetched: false,
      selTabIndex: 0,
      savedPropertiesLoading: false,
      savedProperties: [],
    }
  }

  componentDidMount() {
    this.setState({ searchesFetched: false })
    this.fetchSavedProperties()
    fetchSavedSearches(this.props.user.token).then(response => {
      if (isempty(response.errors)) {
        this.setState({
          savedSearches: response.savedSearches,
          searchesFetched: true,
        })
      }
    })
  }

  componentDidUpdate(prevProps) {
    const { user } = this.props
    if (user.favorites !== prevProps.user.favorites) {
      this.fetchSavedProperties()
    }
  }

  removeSearch = async id => {
    this.setState({
      isRemoving: true,
    })

    try {
      const response = await removeSearch(this.props.user.token, id)

      if (isempty(response.errors)) {
        this.setState(prevState => ({
          savedSearches: [...prevState.savedSearches.filter(savedSearch => savedSearch.id !== id)],
        }))
      }
    } catch (error) {
      this.props.showFlashMessageOnUnexpectedError(error)
    }

    this.setState({
      isRemoving: false,
    })
  }

  buildSearchDescription = rawFilters => {
    let description = []

    const filters = sanitizeFilters(rawFilters)

    if (filters.priceMin || filters.priceMax) {
      description.push(filters.priceMin === filters.priceMax ? `$${amtFmt(filters.priceMin)}` : `$${amtFmt(filters.priceMin)} - $${amtFmt(filters.priceMax)}`)
    }

    if (filters.beds) {
      description.push(`${filters.beds}${filters.beds > 3 ? '+' : ''} ${filters.beds > 1 ? 'Beds' : 'Bed'}`)
    }

    if (filters.baths) {
      description.push(`${filters.baths}${filters.baths > 3 ? '+' : ''} ${filters.baths > 1 ? 'Baths' : 'Bath'}`)
    }

    if (filters.areaMin || filters.areaMax) {
      description.push(
        filters.areaMin === filters.areaMax ? `${amtFmt(filters.areaMin)} Sqft` : `${amtFmt(filters.areaMin)} Sqft - ${amtFmt(filters.areaMax)} Sqft`
      )
    }

    if (filters.homeTypes) {
      description.push(`${filters.homeTypes.join(', ')}`)
    }

    if (filters.types) {
      description.push(`${filters.types.join(', ')}`)
    }

    return description.join(' • ')
  }

  buildSearchUrl = savedSearch => {
    const filters = {
      maxArea: savedSearch.filters.areaMax ? savedSearch.filters.areaMax : 0,
      minArea: savedSearch.filters.areaMin ? savedSearch.filters.areaMin : 0,
      numberOfBath: savedSearch.filters.baths ? savedSearch.filters.baths : 0,
      numberOfBedrooms: savedSearch.filters.beds ? savedSearch.filters.beds : 0,
      propertyType: savedSearch.filters.types ? savedSearch.filters.types.join(',') : '',
      homeType: savedSearch.filters.homeTypes ? savedSearch.filters.homeTypes.join(',') : '',
      min: savedSearch.filters.priceMin ? savedSearch.filters.priceMin : 0,
      max: savedSearch.filters.priceMax ? savedSearch.filters.priceMax : 0,
    }
    const queryString = `address=${savedSearch.location}&propertyType=${filters.propertyType}&homeType=${filters.homeType}&numberOfBedrooms=${
      filters.numberOfBedrooms
    }&numberOfBath=${filters.numberOfBath}&min=${filters.min}&max=${filters.max}&minArea=${filters.minArea}&maxArea=${filters.maxArea}`

    window.location = `${window.location.protocol}//${process.env.REACT_APP_BASE_DOMAINS}${
      window.location.port ? ':' + window.location.port : ''
    }/properties?${queryString}`
  }

  handleChange = (event, newValue) => {
    this.setState({ selTabIndex: newValue })
  }

  fetchSavedProperties = () => {
    if (isUserLogged(this.props.user)) {
      this.setState({
        savedPropertiesLoading: true,
      })
      fetchSavedProperties(this.props.user.token).then(resp => {
        const savedPropertiesLoading = false
        const savedProperties = [...resp.properties.values()]
        this.setState({
          savedPropertiesLoading,
          savedProperties,
          propsFetched: true,
        })
      })
    }
  }

  propertyRemoved = id => {
    // this.props.actions.fetchUserLocation()
    // removed from new listings
    this.setState({
      savedProperties: this.state.savedProperties.filter(property => property.id !== id),
    })
  }

  render() {
    const { savedSearches, searchesFetched, selTabIndex, savedProperties, savedPropertiesLoading, propsFetched } = this.state
    const { classes } = this.props
    return (
      <div className={classes.root}>
        <AppBar position="static" className={classes.appBar}>
          <Tabs value={selTabIndex} onChange={this.handleChange} classes={{ indicator: classes.indicator, root: classes.tabRoot }}>
            <Tab classes={{ selected: classes.selected, root: classes.tabsRoot }} label="Properties" id={`search-tab-0`} aria-controls={`search-tabpanel-0`} />
            <Tab classes={{ selected: classes.selected, root: classes.tabsRoot }} label="Searches" id={`search-tab-1`} aria-controls={`search-tabpanel-1`} />
          </Tabs>
        </AppBar>
        <Typography
          component="div"
          role="tabpanel"
          hidden={selTabIndex !== 0}
          id={`search-tabpanel-0`}
          aria-labelledby={`search-tab-0`}
          className={classes.panel}>
          {selTabIndex === 0 && savedProperties.length > 0 ? (
            <PropertyList onSelect={() => this.toggleDetail()} isLoading={savedPropertiesLoading} properties={savedProperties} from={'saved'} />
          ) : (
            selTabIndex === 0 && savedProperties.length === 0 && propsFetched && <Typography>You haven't saved any properties yet.</Typography>
          )}
        </Typography>
        <Typography
          component="div"
          role="tabpanel"
          hidden={selTabIndex !== 1}
          id={`search-tabpanel-1`}
          aria-labelledby={`search-tab-1`}
          className={classes.panel}>
          {selTabIndex === 1 && savedSearches.length > 0
            ? savedSearches.map(savedSearch => (
                <div key={savedSearch.id} className={classes.card}>
                  <a onClick={() => this.buildSearchUrl(savedSearch)} className={classes.cardLink}>
                    <div className={classes.content}>
                      <Typography variant="caption" className={classes.locationContent}>
                        {savedSearch.location}
                      </Typography>
                      <Typography variant="caption" className={classes.filtersContent}>
                        {this.buildSearchDescription(savedSearch.filters)}
                      </Typography>
                    </div>
                  </a>
                  <Button onClick={() => this.removeSearch(savedSearch.id)} link className={classes.button} isLoading={this.state.isRemoving}>
                    Delete
                  </Button>
                </div>
              ))
            : selTabIndex === 1 && searchesFetched && <Typography>You haven't saved any searches yet.</Typography>}
        </Typography>
      </div>
    )
  }
}

InvestorSavedSearches.propTypes = {
  user: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ showFlashMessageOnUnexpectedError }, dispatch)
}

export default withStyles(styles)(
  connect(
    null,
    mapDispatchToProps
  )(InvestorSavedSearches)
)



// WEBPACK FOOTER //
// ./src/features/investorDashboard/components/InvestorSavedSearches.js